export default "__VITE_ASSET__ec7aa4a5__$_?react__"